var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90106 4.53638C3.96284 4.21492 4.21488 3.96287 4.53635 3.90109L7.14588 3.40046C7.40642 3.35039 7.67503 3.43248 7.86265 3.62005L12.7468 8.50419C13.0591 8.81658 13.059 9.3229 12.7468 9.63529L9.63525 12.7468C9.32286 13.0591 8.81654 13.0591 8.50416 12.7468L3.62001 7.86269C3.43244 7.67506 3.35035 7.40645 3.40042 7.14591L3.90106 4.53638ZM5.53417 5.53421C5.14365 5.92473 5.14365 6.5579 5.53417 6.94842C5.9247 7.33894 6.55786 7.33894 6.94838 6.94842C7.33891 6.5579 7.33891 5.92473 6.94838 5.53421C6.55786 5.14368 5.9247 5.14368 5.53417 5.53421Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/Tag.006f7724dd87bcc04d14844305c8e286.svg";
export { ForwardRef as ReactComponent };